import React from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const Iris = () => {
    return (
        <Grid container spacing={3} className="hermes-container">
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <AutoStoriesOutlinedIcon /> Landing Pages
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Create and manage Marketing Landing Pages, Surveys, Forms and Blog Posts.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Manage Pages
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <PhoneIphoneOutlinedIcon /> Mobile App
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Deploy your own branded React Native mobile app using Iris Portal APIs.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Deploy App
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <LoginOutlinedIcon /> Identity Providers
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Enable and configure sign-in methods such as Email Link, Email OTP, SMS OTP, Salesforce, Auth0, Azure, Google, Apple, Microsoft.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Configure Identity
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <SettingsOutlinedIcon /> Advanced Settings
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Access advanced portal configurations, experimental features and UI theming options.
                        </MDTypography>
                        <MDButton variant="outlined" color="light" component={Link} to="/admin/iris/settings">
                            Open Settings
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Iris;